import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { Modal } from 'common/components/Modal/Modal';
import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';
import InstantBookView from 'pages/profile/components/InstantBookView/InstantBookView';

export const StyledNoAvailabilityModal = styled(Modal)`
  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
    && {
      &.ant-modal {
        max-width: 100vw;
      }
    }
  `)}
`;

export const NoAvailabilityModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;

  row-gap: 20px;
`;

export const NoAvailabilityModalText = styled(BaseBodyText)`
  text-align: center;
`;

export const StyledInstantBookView = styled(InstantBookView)`
  max-width: 100%;
  min-width: 100%;
  border-radius: 16px;
  border: 1px solid ${BRAND_COLORS.lightGray};

  padding: 18px 24px 24px 24px;

  flex: 1;
`;
